module.exports = __webpack_public_path__ + "img/preset3.9be8c528.png";